import { createTheme } from "@mui/material/styles";

const commonSettings = {
    typography: {
        fontFamily: "Arial, sans-serif",
    },
    components: {
        MuiDialog: {
            styleOverrides: {
                paper: ({ theme }) => ({
                    borderRadius: 16,
                    border: `2px solid ${theme.palette.primary.main}`,
                    boxShadow: theme.shadows[10],
                    ...(theme.palette.mode === 'dark' && {
                        backgroundColor: '#000000',
                        backgroundImage: 'none',
                    }),
                }),
            },
        },
    },
};

export const lightTheme = createTheme({
    ...commonSettings,
    palette: {
        mode: "light",
        primary: {
            main: "#5A67D8", // Indigo
        },
        secondary: {
            main: "#434190", // Dark Indigo
        },
        success: {
            main: "#38B2AC", // Teal
        },
        warning: {
            main: "#F6AD55", // Soft Orange
        },
        error: {
            main: "#FC8181", // Soft Red
        },
        info: {
            main: "#63B3ED", // Sky Blue
        },
        background: {
            default: "#F7FAFC",
            paper: "#ffffff",
        },
    },
    gradients: [
        'linear-gradient(135deg, #5A67D8 0%, #434190 100%)', // Indigo
        'linear-gradient(135deg, #38B2AC 0%, #2C7A7B 100%)', // Teal
        'linear-gradient(135deg, #434190 0%, #2A2868 100%)', // Dark Indigo (formerly Lavender)
        'linear-gradient(135deg, #F6AD55 0%, #DD6B20 100%)', // Orange
        'linear-gradient(135deg, #FC8181 0%, #E53E3E 100%)', // Red
        'linear-gradient(135deg, #63B3ED 0%, #3182CE 100%)', // Sky Blue
    ],
    chartColors: ['#5A67D8', '#38B2AC', '#F6AD55', '#FC8181', '#434190', '#63B3ED'],
});

export const darkTheme = createTheme({
    ...commonSettings,
    palette: {
        mode: "dark",
        primary: {
            main: "#7F9CF5",
        },
        secondary: {
            main: "#667EEA", // Lighter Indigo for dark mode contrast
        },
        success: {
            main: "#4FD1C5",
        },
        warning: {
            main: "#FBD38D",
        },
        error: {
            main: "#FEB2B2",
        },
        info: {
            main: "#90CDF4",
        },
        background: {
            default: "#1A202C",
            paper: "#2D3748",
        },
    },
    gradients: [
        'linear-gradient(135deg, #7F9CF5 0%, #5A67D8 100%)',
        'linear-gradient(135deg, #4FD1C5 0%, #38B2AC 100%)',
        'linear-gradient(135deg, #667EEA 0%, #5A67D8 100%)', // Indigo Gradient
        'linear-gradient(135deg, #FBD38D 0%, #F6AD55 100%)',
        'linear-gradient(135deg, #FEB2B2 0%, #FC8181 100%)',
        'linear-gradient(135deg, #90CDF4 0%, #63B3ED 100%)',
    ],
    chartColors: ['#7F9CF5', '#4FD1C5', '#FBD38D', '#FEB2B2', '#667EEA', '#90CDF4'],
});
